import { WebHelper } from "chipply-common";
import IEventCategoriesDto from "../i-event-categories-dto";
import IEventCategoryDto from "../i-event-category-dto";
import IEventBrandingResults from "../IEventBrandingResults";

export class StoreHelper {
    public async getCategories(
        dealerId: number,
        eventId: number,
        categoriesOnly = false
    ): Promise<IEventCategoriesDto> {
        const eventCategories = (await WebHelper.getJsonData(
            `/api/EventProductEcom/GetEventCategories/` + `${eventId}/${dealerId}/0/${categoriesOnly}`,
            true
        )) as IEventCategoriesDto;

        for (const categoryOrPackage of eventCategories.containers) {
            categoryOrPackage.parent = eventCategories;
            const subContainers = (categoryOrPackage as IEventCategoryDto).containers;
            if (subContainers) {
                for (const subcategory of subContainers) {
                    subcategory.parent = eventCategories;
                }
            }
        }

        eventCategories.products?.products.forEach((product) => {
            product.designs = [];
            if (product.colors?.length > 0) {
                product.colors[0].url = product.productUrl;
            }

            for (let i = 0; i < product.designCount; i++) {
                product.designs.push({
                    key: i == 0 ? product.eventProductID : i,
                    value: product.colors,
                });
            }
        });
        return eventCategories;
    }

    public async getBranding(eventId: number): Promise<IEventBrandingResults> {
        let baseUrl = "/api/Event/Branding?eventId=";
        baseUrl += encodeURIComponent(eventId);
        const results = (await WebHelper.getJsonData(baseUrl)) as IEventBrandingResults;
        return results;
    }

    public checkPasswords(selected: IEventCategoryDto | null) {
        const unlockedContainers: any[] = [];
        if (selected && selected.containers) {
            selected.containers.forEach((subCat) => {
                if (!selected.hasPassword || selected.isAuthorized) {
                    unlockedContainers.push(subCat);
                }
            });
        }

        return unlockedContainers;
    }
}
